module.exports = __webpack_public_path__ + "img/donacion_computadores.a77f848a.jpg";